<template>
  <div id="container" v-loading.fullscreen="disabled">
    <!-- checkout -->
    <div class="full_layout" v-if="list">
      <div class="shopping_cart">
        <div class="shopping_box">
          <!-- checkout address -->
          <div class="checkout_box">
            <h3>{{ $t('base.shipTo') }}<span class="text_blue" style="font-weight: normal;" @click="addChange('', 'new')"
                v-if="BusinessType != 2">+{{ $t('base.addNewAddress') }}</span></h3>
            <div class="BusinessType" v-if="BusinessType == 2">{{ $t('alert.cardHobbyAddress') }}</div>
            <!-- <div class="BusinessType" v-if="BusinessType==2">Cards will be sent to Card Hobby Office in Shanghai China for international
              transaction. You can view them in Oversea Warehouse.</div> -->
            <!--  { "Member": null, "MemberId": 11, "Country": "US", "UserName": "qq", "StreetAddress": "ddfdf", "StreetAddress2": "vfbgs", "City": "bnghnh", "StateCode": "AK", "State": "Alaska", "ZipCode": "bgnymedef", "Phone": "123456", "IsDefault": true, "Id": 124, "CreateUser": "system", "CreateDate": "2022-09-28 11:17:17", "LastUpdateUser": "system", "LastUpdateDate": "2022-10-25 17:27:39" } -->
            <ul class="address_list" v-if="address != '' || orderAdd != ''">
              <li v-if="orderAdd && again != undefined" class="on">
                <div class="choose_address">
                  <div class="on_Default" v-if="orderAdd.IsDefault">{{ $t('base.default') }}</div>
                  <div>
                    <span>{{ orderAdd.UserName }}</span>
                    ({{ orderAdd.Country }})
                  </div>
                  <div class="line_txt2"
                    :title="((orderAdd.StreetAddress != null ? orderAdd.StreetAddress + ',' : '') + (orderAdd.StreetAddress2 != null && orderAdd.StreetAddress2 != '' ? orderAdd.StreetAddress2 + ',' : '') + (orderAdd.City != null ? orderAdd.City + ',' : '') + (orderAdd.StateCode != null ? orderAdd.StateCode + ',' : '') + orderAdd.ZipCode)">
                    <span>{{ orderAdd.StreetAddress != null ? orderAdd.StreetAddress + ', ' : '' }}</span>
                    <span v-if="orderAdd.StreetAddress2 != null && orderAdd.StreetAddress2 != ''">{{ orderAdd.StreetAddress2
    != null && orderAdd.StreetAddress2 != '' ? orderAdd.StreetAddress2 + ', ' : '' }}</span>
                    <span>{{ orderAdd.City != null ? orderAdd.City + ', ' : '' }}</span>
                    <span>{{ orderAdd.StateCode != null ? orderAdd.StateCode + ', ' : '' }}</span>
                    <span>{{ orderAdd.ZipCode }}</span>
                  </div>
                  <div>{{ orderAdd.Phone }}</div>
                </div>
              </li>
              <li v-for="(item, index) in address" :key="index" v-if="index < 10"
                :class="{ 'on': (isAdd == index && again == undefined) }">
                <div class="choose_address" @click="addCheck(item, index)">
                  <div class="on_Default" v-if="item.IsDefault">{{ $t('base.default') }}</div>
                  <div><span>{{ item.UserName }}</span> ({{ item.Country }})</div>
                  <div class="line_txt2"
                    :title="((item.StreetAddress != null ? item.StreetAddress + ',' : '') + (item.StreetAddress2 != null && item.StreetAddress2 != '' ? item.StreetAddress2 + ',' : '') + (item.City != null ? item.City + ',' : '') + (item.StateCode != null ? item.StateCode + ',' : '') + item.ZipCode)">
                    <span>{{ item.StreetAddress != null ? item.StreetAddress + ', ' : '' }}</span>
                    <span v-if="item.StreetAddress2 != null && item.StreetAddress2 != ''">{{ item.StreetAddress2
    != null && item.StreetAddress2 != '' ? item.StreetAddress2 + ', ' : '' }}</span>
                    <span>{{ item.City != null ? item.City + ', ' : '' }}</span>
                    <span>{{ item.StateCode != null ? item.StateCode + ', ' : '' }}</span>
                    <span>{{ item.ZipCode }}</span>
                  </div>
                  <div>{{ item.Phone }}</div>
                </div>
                <!-- <span class="change text_blue" v-if="!item.IsDefault" @click="addChange(item,index)">Edit</span> -->
                <span class="change text_blue chage_address" v-if="isAdd == index && again == undefined"
                  @click="addChange(item, index)">{{ $t('base.edit') }}</span>
                <span class="change text_blue chage_address" v-if="again != undefined"
                  @click="addChange(item, index)">{{ $t('base.edit') }}</span>
              </li>
            </ul>
          </div>
          <!-- checkout pay -->
          <div class="checkout_box">
            <h3>{{ $t('base.payWith') }}</h3>
            <ul class="pay_list">
              <li :class="{ 'on': (checkPay == item.LowerName), 'disabled': (item.isPrice == false) }" @click="payCheck(item)"
                v-for="(item, index) in payChannelsList" :key="index">
                <el-tooltip :disabled='item.isPrice' popper-class="j" effect="dark"
                  :content="$t('base.USDTMinAmount', { price: item.MinAmount })" placement="top">
                  <div class="pay_list_div">
                    <el-image class="like_img" :src="payChannels[item.LowerName]" fit="contain"></el-image>
                  </div>
                </el-tooltip>
              </li>
            </ul>
            <!-- <ul class="pay_list" v-if="antPayChannelsList.length>0">
              <li v-if="item.PaymentMethodCategory!='CARD'" :class="{'on':paymentMethodType==item.PaymentMethodType}" @click="antPayCheck(item)" v-for="(item,index) in antPayChannelsList" :key="index">
                <el-image class="like_img" :src="item.Logo.LogoUrl" fit="contain"></el-image>
              </li>
            </ul>
            <div v-if="isOtherPay" class="others"><span @click='getAntPay()'>Others</span></div> -->
          </div>
          <el-alert :title="$t('alert.afterPay')" type="warning" :closable="false" show-icon class="RemainingAlert">
          </el-alert>
          <!-- checkout detail -->
          <div class="checkout_box">
            <h3>{{ $t('base.reviewItemsShipping') }}</h3>
            <div class="table_head">
              <div class="commod head_box">{{ $t('base.item') }}</div>
              <div class="head_box">{{ $t('base.itemPrice') }}</div>
              <div class="head_box">{{ $t('base.ForwardingOrderTotal') }}</div>
              <div class="head_box">{{ $t('base.weighed') }}</div>
            </div>
            <div class="review_list" v-if="list&&list.CreateDate">
              <div class="history_list_title">
                <div>{{ list.CreateDate | setTimeSS }}
                  <template v-if="list&&list.OrderDetails">
                    <span>{{ $tc('base.ItemsTotal', list.OrderDetails.length, { n: list.OrderDetails.length }) }}</span>
                  </template>
                </div>
                <template>
                  <div v-if="list && list.itemPriceTotal">
                    <span class="text_blue DownloadPurchaseDetails"
                      @click="setPrompt(list._id)">{{ $t('base.DownloadPurchaseDetails') }}</span>
                  </div>
                </template>

              </div>
              <div class="shopping_list">
                <div class="flex_one">
                  <div v-for="(item, index) in list.Details" :key="index" class="flex_one flex shopList">
                    <div class="like_box">
                      <el-image class="like_img" :src="item.TitImg" fit="contain"></el-image>
                      <p class="line_txt4"><span class="line_txt4">{{ item.Title }}</span></p>
                    </div>
                    <div class="list_price">
                      <template v-if="item.RealLowestPrice">
                        <!-- {{areaSymbol}} {{ item.RealLowestPrice||setPrice(item.Price) }} -->
                        {{ areaSymbol }} {{ formatAmount(item.RealLowestPrice) }}
                      </template>
                    </div>
                  </div>
                </div>
                <div class="head_box">
                  <template v-if="list.itemPriceTotal">
                    {{ areaSymbol }} {{ formatAmount(list.itemPriceTotal) }}
                  </template>
                </div>
                <div class="head_box">{{ list.Weight ? list.Weight + 'kg' : '/' }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="Checkout">
          <!-- <div class="check_list">
            <span v-if="list&&list.Details">{{list.Details.length != 1?'Items':'Item'}} ({{list.Details.length}})</span>
          </div> -->
          <div class="check_list">
            <span>{{ $t('base.stateTax') }}</span>
            <span class="price">{{ list.RealTaxPrice ? areaSymbol + ' ' + list.RealTaxPrice : '/' }}</span>
          </div>
          <div class="check_list">
            <span>{{ $t('base.weighed') }}</span>
            <span class="price">{{ list.Weight ? list.Weight + 'kg' : '/' }}</span>
            <!-- <span class="price">{{item.RealPayPostageMoney && item.RealPayPostageMoney>0 ?areaSymbol+' '+item.RealPayPostageMoney:'/'}}</span> -->
          </div>
          <div class="check_list">
            <span>{{ $t('base.cardhobbyPay') }}</span>
            <span class="price">{{ PayPostageMoney && PayPostageMoney > 0 ? areaSymbol + ' ' + PayPostageMoney : '/' }}</span>
            <!-- <span class="price">{{item.RealPayPostageMoney && item.RealPayPostageMoney>0 ?areaSymbol+' '+item.RealPayPostageMoney:'/'}}</span> -->
          </div>
          <div class="check_list">
            <span>{{ $t('base.shippingTo') }} {{ BusinessType == 2 ? 'Card Hobby' : checkAdd.ZipCode }}</span>
            <span class="price">{{ areaSymbol }} {{ PostageMoney }}</span>
          </div>
          <div class="check_list" v-if="couponList&&couponList.length>0">
            <el-select v-model="couponId" class="couponSelect" popper-class="coupon-select" @change="changeCoupon">
              <el-option v-for="(item,index) in couponList" :key="index" :value="item._id" :label="item.CouponTemplateName" :disabled="item.IsUse==2">
                <div class="coupon-item">
                    <div class="couponPrice">
                      <div>{{areaSymbol}} {{areaSymbol=='MOP'?item.CouponAmountMop:item.CouponAmountUsd}} {{ $t('base.off') }}</div>
                      <div>{{item.EndTime|setTimeSS}}</div>
                    </div>
                </div>
              </el-option>
            </el-select>
            <span class="price" style="line-height: 3;" v-if="CouponsPrice>0">- {{ areaSymbol }} {{CouponsPrice}}</span>
          </div>
          <!-- {{couponList}} -->
          <div class="check_list check_list_all">
            <span>{{ $t('base.orderTotal') }}</span>
            <span>{{ areaSymbol }} {{ totalPostageMoney }}</span>
          </div>
          <div class="check_list">
            <i18n path="alert.agreementAPrivacy" tag="p" class="text_gray">
              <router-link class="text_blue" :to="{ path: '/terms/privacy?type=2' }"
                target="_blank">{{ $t('base.service') }}</router-link>
              <router-link class="text_blue" :to="{ path: '/terms/privacy?type=1' }"
                target="_blank">{{ $t('base.privacy') }}</router-link>
            </i18n>
          </div>
          <el-button class="check_btn" type="primary" :disabled="disabled"
            @click='addOrder'>{{ $t('base.confirmPay') }}</el-button>
          <span class="text_gray finish">{{ $t('alert.checkoutOn') }} {{ checkPayUpper }}</span>
        </div>
      </div>
    </div>
    <!-- edit address -->
    <get-address v-if="dialogVisible" :dialogVisible.sync="dialogVisible" :checkAdd.sync="checkAdd" :isNew.sync="isNew"
      :getAreas.sync="getAreas" :userInfo.sync="userInfo" :type='0' />
  </div>
</template>
<script>
//从app.vue 往 Child.vue中传递信息。
import bus from '@/api/bus';
import GetAddress from "@/components/dialog/orderaddress"; // 收货地址

import { getInfo, addressList, numAdd, numMulti, setInfo, getTime,setUTC, isNumber, prompt, goPay, formatAmount, GetWorldUSD, setPayList } from "@/api/public";
export default {
  name: 'index',
  components: {
    GetAddress
  },
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      pi:1,
      ps:99,
      PostageMoney: 0, // 邮费
      totalPostageMoney: 0,
      PayPostageMoney: 0, // 代付邮费
      WarehousePrice: 0, // 仓储费
      CouponsPrice:0,//优惠券金额
      couponList:'',//优惠券列表
      couponId:'',//优惠券id
      userInfo: '',
      isNew: false,
      Coupon: 0,
      dialogVisible: false,
      address: [],
      getAreas: '',
      checkAdd: '',
      newAdd: '',
      orderAdd: '',
      isAdd: '',
      isUSDT: -1,
      isCheck: false,
      checkPay: 'stripe',
      checkPayUpper: 'Stripe',
      payChannelsList: [],
      antPayChannelsList: [],
      paymentMethodType: '',
      isOtherPay: false,
      payChannels: this.$enumInfo.payChannels,
      payEnum: this.$enumInfo.paylist,
      IsGuarantee: 6,
      Subtotal: 0,
      num: 1,
      value: '',
      list: '',
      BusinessType: '',
      again: '',
      disabled: false,
      IfDefault: true,
      passForm: {
        Country: "US",
        UserName: '',
        StreetAddress: '',
        StreetAddress2: '',
        City: '',
        StateCode: '',
        State: '',
        ZipCode: '',
        Phone: '',
      }
    }
  },
  watch: {
    '$route': 'getPath'
  },
  computed:{
    // setTotalMoney(){
    //   return function(price){
    //     return price-this.CouponsPrice
    //   }
    // },
  },
  filters: {
    setTimeSS(val) {
      //console.log(val);
      return getTime(val, -8, '', 'cn')
    }
  },
  mounted() { },
  created() {
    this.userInfo = getInfo()
    
    //this.GetMyCoupon()
    // this.$nextTick(() => {
    //                 })
    GetWorldUSD()
    this.isPayChannels()
    this.getAreasList();
    bus.$emit('headerTitle', this.$t('title.checkout'));
    // this.list = window.sessionStorage.getItem('check');
    // //console.log(this.list)
    // this.list = JSON.parse(this.list);
    //console.log(this.list)

  },
  methods: {
    formatAmount(price) {
      return formatAmount(price)
    },
    setPrompt(orderId) {
      try {
        prompt(orderId);
      } catch (e) {
        console.log(e)
      }
    },
    //获取优惠券列表
    GetMyCoupon() {
      const that=this;
      let data = { operator_id: this.userInfo.MappingUserId, memberid: this.userInfo.MappingUserId, token: this.userInfo.ChineseToken, orderId:this.again }
      return that.$get(this.$interface.GetCouponByOrderId, data).then(res => {
        if (res.Result > 0) {
          that.couponList = res.Data;
          res.Data.map(item=>{
            let val = setUTC(item.EndTime, -8, 'cn')
            let newval = setUTC(new Date().getTime(), -8)
            if(newval>=val){
              item.IsUse=2
            }
          })
          that.couponList = res.Data;
        }else{

        }
      })
    },
    setOrderCoupon(e){},

    /**
     * 格式化运费金额显示
     * @param {Object} val - 包含 RealPayPostageMoney 属性的对象
     * @param {string} areaSymbol - 货币符号
     * @returns {string} 格式化后的运费金额字符串，格式为"货币符号 + 金额"，无运费时返回"/"
     */
    setExchange(val, areaSymbol) {
      // console.log(val,areaSymbol,'val')
      var num = val.RealPayPostageMoney
      if (num > 0 && num != null) {
        // num='$ '+priceExchange(num,'USD')
        num = areaSymbol + ' ' + num
      } else {
        num = '/'
      }
      //&&item.PayPostageMoney>0 && item.PayPostageMoney!=null ? '$ '+item.PayPostageMoney:'/'
      return num
    },
    setPrice(price) {
      let that = this
      let newPrice = price
      newPrice = numMulti(price, that.list.ExchangeRate).toFixed(2);
      return newPrice
    },
    // 获取支付渠道
    /**
     * 获取支付渠道列表并设置默认支付方式
     * 通过用户所在区域获取可用的支付渠道,处理支付列表数据
     * 设置默认支付方式及相关支付参数
     * 检查是否包含USDT和其他支付方式(蚂蚁金服)
     * 如果获取失败则设置默认支付方式为stripe
     * @method isPayChannels
     * @private
     */
    isPayChannels() {
      let that = this

      let data = { AreaCode: that.userInfo.MemberSource }
      that.$get(that.$interface.GetPayChannels, data).then(res => {
        if (res.Result != 0) {

          let data = res.Data
          // if (that.userInfo.MemberSource == 'MO') {

          //   data = setPayList(data, that.userInfo,'stripe')
          // }else{

          //   data = setPayList(data, that.userInfo)
          // }
          data = setPayList(data, that.userInfo)

          // console.log(i)
          data.map((item, i) => {
            console.log(item.ChannelName == 'USDT')
            if (item.ChannelName == 'USDT') {
              that.isUSDT = i
            }
          })
          that.checkPay = data[0].LowerName
          that.checkPayUpper = data[0].ChannelName
          that.IsGuarantee = that.payEnum[that.checkPay]
          that.payChannelsList = data
          //其他支付方式=》蚂蚁金服
          let isOther = data.filter(item => {
            return item.LowerName == 'other'
          })
          if (isOther.length > 0) {
            that.isOtherPay = true
          }
          //end
        } else {
          that.checkPay = 'stripe'
          that.checkPayUpper = 'Stripe'
          // if (that.userInfo.MemberSource == 'MO') {
          //   that.checkPay = 'mpay'
          //   that.checkPayUpper = 'MPay'
          // }
          that.IsGuarantee = that.payEnum[that.checkPay]
        }

        that.isAgain()
      }).catch(res => {
        that.checkPay = 'stripe'
        that.checkPayUpper = 'Stripe'
        // if (that.userInfo.MemberSource == 'MO') {
        //   that.checkPay = 'mpay'
        //   that.checkPayUpper = 'MPay'
        // }
        that.IsGuarantee = that.payEnum[that.checkPay]

        that.isAgain()
      })

    },

    // 判断是否有订单号
    async isAgain() {
      let that = this
      this.again = this.$route.params.id;
      if (this.again != undefined) {
        try {
          await that.GetMyCoupon()
        } catch (error) {
          console.error('GetMyCoupon failed:', error)
        } finally {
          that.GetOrder()
        }
      } else {
        ///这个判断基本废弃了
        // console.log(this.list, this.list.Details, 'this.list.Details')
        // var details = this.list.Details;
        // var Shippingfee = 0
        // details.map(res => {
        //   Shippingfee += isNumber(res.PayPostageMoney)
        //   //console.log(Shippingfee,res.PayPostageMoney,res, 'Shippingfee')
        // })
        // that.PayPostageMoney = priceExchange(Shippingfee, 'USD')
        //console.log(Shippingfee)
      }
      //this.GetMember();
    },
    /**
     * 获取订单详情
     * 通过订单ID获取订单信息,包括收货地址、支付渠道、订单金额等
     * 处理地址格式化,设置支付方式,计算运费和总价
     * 检查USDT支付最低限额
     * @private
     * @returns {void}
     */
    GetOrder() {
      let that = this
      let data = { Id: this.again }
      that.$get(that.$interface.GetOrderById, data).then(res => {
        if (res.Result != 0) {
          var result = res.Data
          res.Data.Details = res.Data.OrderDetails
          that.areaSymbol = res.Data.RealOrderPriceUnit

          var itemPriceTotal = 0
          var orderDetails = result.OrderDetails
          orderDetails.map(item => {
            if (item.RealLowestPrice) {
              itemPriceTotal = numAdd(itemPriceTotal, item.RealLowestPrice)
            } else {
              // var Price=numMulti(item.Price,result.ExchangeRate)
              // itemPriceTotal=numAdd(itemPriceTotal,Price)
              itemPriceTotal = 0
              return
            }
          })
          result.itemPriceTotal = itemPriceTotal ? itemPriceTotal.toFixed(2) : 0
          that.list = result;
          if (that.payChannelsList.length <= 1 && that.payChannelsList.length > 0) {
            that.checkPay = that.payChannelsList[0].ChannelName
          }

          let address = res.Data.Address
          let add = address.AddressDetail

          if (add.indexOf('()') > 0) {
            // var a=add1.indexOf('()')
            // console.log(add1,a,'add2',add1.substring(0,a))
            //var reg=new RegExp()
            add = add.replace(/\(\)/g, "")
            add = [add]
            //console.log(add1,a,'add1')
          } else {
            if (add.indexOf(')') != -1) {
              add = add.replace(")", "")
              add = add.replace("(", "|")
            }
            add = add.split("|")
          }
          let result = {
            UserName: address.Consignee,
            Country: address.Nation,
            StreetAddress: add[0],
            StreetAddress2: add[1] ? add[1] : '',
            City: address.City,
            State: address.Provice,
            ZipCode: address.ZipCode,
            Phone: address.Mobile,
            StateCode: address.Provice,
          }
          if (this.getAreas) {
            this.getAreas.map(item => {
              if (result.StateCode == item.Code) {
                result.State = item.EName
              } else if (result.State == item.EName) {
                result.StateCode = item.Code
              }
            })
          }
          that.orderAdd = result
          //that.GetPostageMoney(res.Data.Address)
          // console.log(res.Data.RealPostageMoney, 'res.Data.RealPostageMoney')
          that.PostageMoney = res.Data.RealPostageMoney

          that.PayPostageMoney = res.Data.RealPayPostageMoney

          // console.log(that.PayPostageMoney,that.PostageMoney, isNumber(res.Data.RealPostageMoney)+res.Data.RealWarehousePrice,'res22')
          that.totalPostageMoney = res.Data.RealOrderPrice
          //console.log(that.isUSDT,'isUSDT')
          try{
            if(res.Data.CouponId){
              that.couponId=res.Data.CouponId
              that.CouponsPrice=res.Data.CouponPrice
            }
          }catch(e){
            console.log(e,'error Coupon')
          }
          try {
            if (that.isUSDT > -1) {
              var usdtPrice = that.payChannelsList[that.isUSDT].MinAmount
              //console.log(usdtPrice,'usdtPrice')
              if (usdtPrice > that.totalPostageMoney) {
                that.payChannelsList[that.isUSDT].isPrice = false
                //console.log(that.payChannelsList,'payChannelsList')
                if (that.checkPay == 'usdt' && !that.isCheck) {
                  var index = that.isUSDT == 0 ? 1 : 0
                  that.payCheck(that.payChannelsList[index])
                  that.isCheck = !that.isCheck
                }
              }
            }
          } catch (error) {
            console.log(error,'error USDT')
          }

          // console.log(totalPostageMoney, 'res111')


          this.getAddressList();

        }
        that.disabled = false
      })
      //GetOrderById
    },
    /**
     * 设置订单地址列表并处理地址更新
     * @param {Object} obj - 新的地址对象，包含 City、Country、Phone、state、StreetAddress、StreetAddress2、UserName、ZipCode 等字段
     * @description 
     * - 比对并更新现有地址列表
     * - 移除重复地址
     * - 保留默认地址标记
     * - 处理支付渠道选择
     */
    setOrderAddressList(obj) {
      let that = this
      let add = that.address

      // console.log("987654321", add)
      add.map((res, i) => {
        let oldadd = res.City + res.Country + res.Phone + res.state + res.StreetAddress + res.StreetAddress2 + res.UserName + res.ZipCode
        let newadd = obj.City + obj.Country + obj.Phone + obj.state + obj.StreetAddress + obj.StreetAddress2 + obj.UserName + obj.ZipCode

        // console.log(oldadd == newadd, oldadd, newadd)
        if (oldadd == newadd) {
          if (res.IsDefault) {
            that.orderAdd.IsDefault = true
          }
          this.address.splice(i, 1)
        }
      })
      if (that.again != undefined) {

        if (that.payChannelsList.length <= 1 && that.payChannelsList.length > 0) {
          var ChannelName = that.payChannelsList[0].LowerName
          if (that.checkPay != ChannelName) {
            that.payCheck(that.payChannelsList[0])
          }
        }
      }
      //console.log(1212, that.orderAdd)

      //console.log(that.address, obj, 'that.address')
    },
    //新增订单and 更新订单
    addOrder() {
      let that = this
      that.disabled = true;
      if (this.again != undefined) {

        that.payOrder(this.again)
        //goPay('Tpay', ('?id=' + this.again))
        // if (this.checkPay == 'stripe') {
        //   goPay('Tpay', ('?id=' + this.again))
        // } else {
        //   goPay('Tpaypal', ('?paysource=1&id=' + this.again))
        // }
      } else {
        var add = that.checkAdd
        let add1 = add.StreetAddress || ''
        let add2 = add.StreetAddress2 ? '(' + add.StreetAddress2 + ')' : ''
        let address = {
          AddressId: add.Id,
          Consignee: add.UserName,
          Mobile: add.Phone,
          ZipCode: add.ZipCode,
          Provice: add.StateCode,
          //Provice: add.State,
          City: add.City,
          AddressDetail: add1 + add2,
          Nation: that.userInfo.MemberSource,
        }
        let data = { MemberId: that.userInfo.MappingUserId, AgencyId: that.list.Agency._id, DataSource: that.userInfo.MemberSource, Address: address, PayType: this.checkPay }
        let url = this.$interface.SetOrder
        if (this.address.length <= 0) {
          let msg = this.$t('alert.noAddress')
          this.$message({
            type: 'error',
            // message: res.msg
            message: msg
          });
          that.disabled = false;
        } else {
          this.$post(url, data).then(res => {
            //console.log(res)
            if (res.result != 0) {
              let orderid = ''
              if (that.again != undefined) {
                orderid = that.again
              } else {
                orderid = res.Data.OrderId
              }
              that.payOrder(this.again)
              //goPay('Tpay', ('?id=' + orderid))
              // if (this.checkPay == 'stripe') {
              //   goPay('Tpay', ('?id=' + orderid))
              // } else {
              //   goPay('Tpaypal', ('?paysource=1&id=' + orderid))
              // }
              //window.location.href = this.$interface.Tpay + '?id=' + orderid
              //console.log(res)
            } else {
              that.disabled = false;
              this.$message({
                type: 'error',
                message: res.msg
              });
            }
          }).catch({})
        }
      }

    },
    // 支付
    //获取地址列表  type新添加地址
    getAddressList(type) {
      let that = this
      addressList().then(res => {
        setInfo('Count', res.Count ? res.Count : 0)
        if (res.Result != 0) {
          this.address = res.Data
          if (that.again != undefined) {
            console.log("1231456765432")
            that.setOrderAddressList(that.orderAdd)
          } else {
            this.address.map((val, i) => {
              if (val.IsDefault) {
                this.checkAdd = val
                this.isAdd = i;
                that.GetPostageMoney(val)
              }
            })
          }
        }
      })
    },
    //获取邮费
    /**
     * 获取邮费金额
     * @param {Object} obj - 包含州代码或省份信息的对象
     * @param {string} obj.StateCode - 州代码
     * @param {string} obj.Provice - 省份
     * @description 根据提供的地址信息计算邮费，并更新总邮费金额
     * @returns {void} 无返回值，直接更新组件内的 PostageMoney 和 totalPostageMoney
     */
    GetPostageMoney(obj) {
      let that = this;
      let data = { provice: obj.StateCode || obj.Provice, nation: 'US' }
      this.$get(this.$interface.GetPostageMoney, data).then(res => {
        //console.log(res, 'daa')
        if (res.Result != 0) {
          //console.log(res.Data.USD, 'daa')
          this.PostageMoney = res.Data.USD
        }
        that.totalPostageMoney = numAdd(isNumber(that.PostageMoney), isNumber(that.PayPostageMoney))

        //#
        //console.log(res)
      })
      //console.log(obj, 'obj')
    },
    //获取地区列表
    getAreasList() {
      let that = this;
      let data = { code: that.userInfo.MemberSource }
      this.$get(this.$interface.GetAreas, data).then(res => {
        if (res.Result != 0) {
          that.getAreas = res.Data;
        }
      })
    },
    //设置地址选中更新订单
    addCheck(obj, val) {
      let that = this
      if (this.again != undefined) {
        that.disabled = true;
        let add1 = obj.StreetAddress || ''
        let add2 = obj.StreetAddress2 ? '(' + obj.StreetAddress2 + ')' : ''
        let address = {
          AddressId: obj.Id,
          Consignee: obj.UserName,
          Mobile: obj.Phone,
          ZipCode: obj.ZipCode,
          //Provice: obj.StateCode,
          Provice: obj.State,
          City: obj.City,
          AddressDetail: add1 + add2,
          Nation: obj.Country,
        }
        let data = { id: this.again, DataSource: obj.Country, Address: address, MemberId: that.userInfo.MappingUserId, PayType: that.checkPay }
        let url = this.$interface.UpdateModifyOrder;
        that.$post(url, data).then(res => {
          if (res.result != 0) {
            that.GetOrder()
            this.checkAdd = obj
          }
        })
      } else {
        // 大概率废弃
        if (val != this.isAdd) {
          this.isAdd = val;
          this.checkAdd = obj
          this.GetPostageMoney(obj)
        }
      }
    },
    //select 州
    getState(val) {
      let that = this
      that.getAreas.map(res => {
        if (res.Code == val) {
          that.checkAdd.State = res.EName
        }
      })
    },
    payCheck(val) {
      if (val.isPrice) {
        this.checkPay = val.LowerName;
        this.checkPayUpper = val.ChannelName;
        this.IsGuarantee = this.payEnum[val.LowerName]
        this.paymentMethodType = ''
      }
    },

    // 修改蚂蚁支付方式
    antPayCheck(item) {
      let that = this
      that.paymentMethodType = item.PaymentMethodType
      that.checkPayUpper = item.PaymentMethodCategory
      that.checkPay = 'other';
      that.IsGuarantee = that.payEnum['other']
    },

    // 获取蚂蚁金融的支付方式
    getAntPay(type) {
      let that = this
      let price = that.totalPostageMoney
      let data = { currency: that.areaSymbol, deviceType: 1, userRegion: that.userInfo.MemberSource, amount: price }
      that.disabled = true;
      that.$post(that.$interface.GetAntPayChannels, data).then(res => {
        if (res.Result) {
          that.antPayChannelsList = res.Data
          that.isOtherPay = !that.isOtherPay
          if (type == 'order') {
            that.antPayCheck(that.antPayChannelsList[0])
          }
        } else {
          that.$message({
            type: 'error',
            message: res.Msg
          });
        }
        that.disabled = false;
      })
    },
    //新增地址
    addChange(obj, val) {
      this.dialogVisible = true
      if (val == 'new') {
        this.isNew = true;
        this.newAdd = this.checkAdd;
        if (this.userInfo.MemberSource == "MO") {
          this.passForm.Country = this.userInfo.MemberSource
        }
        this.passForm.Country = this.userInfo.MemberSource
        this.checkAdd = this.passForm;
        this.IfDefault = false;
      } else {
        this.checkAdd = obj
        this.isNew = false;
        this.IfDefault = true;
      }
    },
    //保存地址
    submitForm(formName) {
      let that = this;
      // console.log(this.checkAdd)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let url = this.$interface.SaveAddresses
          let data = {
            "memberId": that.userInfo.Id,
            "country": that.checkAdd.Country,
            "userName": that.checkAdd.UserName,
            "streetAddress": that.checkAdd.StreetAddress,
            "streetAddress2": that.checkAdd.StreetAddress2,
            "city": that.checkAdd.City,
            "stateCode": that.checkAdd.StateCode,
            "state": that.checkAdd.State,
            "zipCode": that.checkAdd.ZipCode,
            "phone": that.checkAdd.Phone
          }
          if (!this.isNew) {
            url = this.$interface.UpdateAddresses;
            data.id = that.checkAdd.Id
            data.isDefault = that.checkAdd.IsDefault
          }
          this.$post(url, data).then(res => {
            if (res.Result != 0) {
              this.getAddressList();

              that.$refs[formName].resetFields();
              that.dialogVisible = false
            } else {
              that.disabled = false;
              this.$message({
                type: 'error',
                message: res.Msg
              });
            }
          })
          //console.log(url, data)
        }
      });
      //this.dialogVisible = false
    },
    //取消保存地址
    resetForm(formName) {
      this.checkAdd = this.newAdd;
      this.$refs[formName].resetFields();
      this.dialogVisible = false
    },
    changeCoupon(e){
      const that=this;
      let isExpire=false
      const oldCouponId=that.list.CouponId
      const oldCouponPrice=that.list.CouponPrice
      that.couponList.map(res=>{
        if(res._id==oldCouponId){
          if(res.IsUse==2){
            isExpire=true
          }
        }
        if(res._id==that.couponId){
          that.CouponsPrice=res.CouponAmountUsd;
          if(that.areaSymbol=='MOP'){
            that.CouponsPrice=res.CouponAmountMop
          }
        }
      })
      if(isExpire){
        this.$confirm(that.$t('alert.UseCoupon'), '', {
          confirmButtonText: that.$t('base.yes'),
          cancelButtonText: that.$t('base.no')
        }).then(() => {
          that.setUseCoupon()
        }).catch(() => {
          that.couponId=oldCouponId
          that.CouponsPrice=oldCouponPrice;        
        });
      }else{
        that.setUseCoupon()
      }
      return
      if(that.couponId){
        if(that.couponId===that.list.CouponId){
          that.$post(that.$interface.OrderCancelUseCoupon, {CouponId:that.couponId,OrderId:that.again}).then(res => {
            if(res.Result>0){
              that.list.CouponId=that.couponId=''
              that.CouponsPrice=0
              that.totalPostageMoney=res.Data.RealOrderPrice
            }else{
              that.$message({
                type: 'error',
                message: res.Msg
              });
            }
          })
        }else{
          that.$post(that.$interface.OrderUseCoupon, {CouponId:that.couponId,OrderId:that.again}).then(res => {
            if(res.Result>0){
              that.list.CouponId=that.couponId
              that.totalPostageMoney=res.Data.RealOrderPrice
            }else{
              that.$message({
                type: 'error',
                message: res.Msg
              });
            }
          })
        }
      }
    },
    setUseCoupon(){
      const that=this;
      that.$post(that.$interface.OrderUseCoupon, {CouponId:that.couponId,OrderId:that.again}).then(res => {
            if(res.Result>0){
              that.list.CouponId=that.couponId
              that.totalPostageMoney=res.Data.RealOrderPrice
            }else{
              that.$message({
                type: 'error',
                message: res.Msg
              });
            }
          })

    },
    // 支付
    payOrder(id) {
      var orderid = id && id != null ? id : this.again

      if (this.checkPay == 'stripe') {
        goPay('Tpay', ('?id=' + orderid))
      } else if (this.checkPay == 'paypal') {
        //goPay('Tpaypal', ('?paysource=1&id=' + orderid))
        goPay('Tpaypal', ('&Id=' + orderid))
      } else if (this.checkPay == 'mpay') {
        goPay('MTpay', ('?id=' + orderid))
      } else if (this.checkPay == 'other') {
        goPay('antTpay', ('?Id=' + orderid + '&PaymentMethodType=' + this.paymentMethodType + '&DeviceType=1'))
      } else if (this.checkPay == 'usdt') {
        goPay('Tusdt', ('?Id=' + orderid))
      }
    }
  },
  //离开页面后
  destroyed() {

    //alert(2);
  }
}

</script>
<style scoped>
@import "../../../static/css/paycart.css";

.shopping_cart {
  margin: 40px 0;
}

.checkout_box h3 {
  font-size: 24px;
  line-height: 1;
  margin: 0 0 16px;
  display: flex;
}

.checkout_box h3>span {
  font-size: 14px;
  margin-top: 9px;
  margin-left: 12px;
  cursor: pointer;
}

.shopping_box {
  border: none;
}

.shopping_list {
  width: 100%;
  padding: 0;
  margin: 12px 0;
}

.shopping_list .like_box {
  display: flex;
  position: relative;
  width: auto;
  flex: 1;
  margin-left: 12px;
}

.shopping_list .like_box p {
  width: auto;
  flex: 1;
}

.shopping_list .list_price {
  min-width: 100px;
  width: auto;
  padding: 0 12px;
  text-align: right;
  margin: 0;
}

.avatar_box {
  display: flex;
  height: 40px;
  line-height: 40px;
  background-color: #f7f7f7;
  padding: 0 12px;
}

.avatar {
  width: 16px;
  height: 16px;
  line-height: 16px;
  margin-top: 12px;
  margin-right: 5px;
}

.review_list {
  border: 1px solid #f7f7f7;
  margin-top: 20px;
}

.table_head {
  min-height: 48px;
  display: flex;
  background-color: #f7f7f7;
  border-bottom: 1px solid #e0e0e0;
  align-items: center;
}

.head_box {
  width: 120px;
  padding: 0 12px;
  text-align: right;
}

.commod {
  width: 545px;
  padding-left: 110px;
  text-align: left;
}

.address_list,
.pay_list {
  display: flex;
  flex-wrap: wrap;
}

.pay_list li {
  border: 1px solid #c8c8c8;
  position: relative;
  cursor: pointer;
  width: 185px;
  margin-right: 20px;
  margin-bottom: 32px;
  height: 38px;
  text-align: center;
}

.pay_list li.disabled {
  background: #f7f7f7;
}

.pay_list li .pay_list_div {
  width: 100%;
  height: 100%;
}

.pay_list li .like_img {
  width: 100px;
  height: 24px;
  margin-top: 8px;
}

.pay_list li.on {
  border-color: #5f6dae;
  background: #f0f3ff;
}

.pay_list li.on:before {
  content: "";
  border: 1px solid #fff;
  border-top: none;
  border-left: none;
  width: 3px;
  height: 6px;
  position: absolute;
  transform: rotate(45deg);
  bottom: 3px;
  right: 3px;
  z-index: 2;
}

.pay_list li.on::after {
  content: "";
  border: 10px solid transparent;
  position: absolute;
  border-bottom-color: #5f6dae;
  border-right-color: #5f6dae;
  right: -1px;
  bottom: -1px;
}

.info_box {
  width: 240px;
  margin-left: 24px;
}

.address_box {
  width: 100%;
  display: flex;
}

.address_list_box {
  width: 160px;
}

.checkbox_save {
  margin-left: 24px;
}

.dialogBox {
  width: 875px;
}

.set_btn {
  text-align: right;
}

.Checkout {
  font-weight: normal;
}

.check_list_all,
.check_list .price {
  font-weight: bold;
}

.check_list .Couponprice {
  font-weight: bold;
  line-height: 36px;
}

.check_list .info_ipt {
  width: 100px;
}

.finish {
  margin: 10px auto 0;
  display: block;
  text-align: center;
}

.BusinessType {
  font-size: 16px;
  padding-bottom: 20px;
}

.address_list li {
  height: 145px;
  border: 2px dashed #e0e0e0;
  margin-right: 8px;
  margin-bottom: 32px;
  padding: 0;
  min-height: 100px;
  width: 278px;
  position: relative;
  cursor: pointer;
}

.address_list li>.choose_address {

  box-sizing: border-box;
  padding: 20px;
  width: 278px;
  padding-bottom: 30px
}

.choose_address>div {
  margin-bottom: 10px;
}

.address_list li.on .change {
  position: absolute;
  z-index: 2;
  right: 12px;
  bottom: 24px;
  font-size: 14px;
  margin: 0;
  left: auto;
}

.table_head .head_box {
  width: 120px;
}

.table_head .commod {
  flex: 1;
  width: auto;
  padding: 0;
  padding-left: 110px;
  text-align: left;
}

.address_box.country {
  margin-bottom: 10px;
  position: relative;
}

.address_box.country .currently {
  position: absolute;
  top: 65px;
  left: 24px;
  font-size: 12px;
  color: #999;
}

.line_txt4 {
  height: 78px;
}

.shopping_list .like_box p .line_txt4 {
  display: -webkit-box;
  height: auto;
}

.RemainingAlert {
  width: 400px;
  margin-bottom: 30px;
}

.others {
  text-align: center;
  font-size: 16px;
  color: #a0a0a0;
  margin-bottom: 20px;
}

.others>span {
  cursor: pointer;
  position: relative;
}

.others>span:after {
  content: "";
  width: 12px;
  height: 7px;
  background: url(../../../static/images/icon/icon_stroke.svg) no-repeat;
  background-size: contain;
  margin-left: 4px;
  display: inline-block;
}


.history_list_title {
  display: flex;
  justify-content: space-between;
  background-color: #f7f7f7;
  color: #a0a0a0;
  padding: 10px 16px;
}

.shopList+.shopList {
  margin-top: 14px;
}

.couponSelect{
  width: 60%;
}

.coupon-select .el-select-dropdown__item{
  height: auto;
    text-decoration: unset;
    padding-left: 7px;
}
.coupon-select .el-select-dropdown__item+.el-select-dropdown__item{    
  padding-top: 10px;
  margin-top: 10px;
  border-top:1px solid #ccc;
}
.coupon-item{
    height: 100%;
    line-height: 1.5;
}
.coupon-select .el-select-dropdown__item .couponPrice{
}
.coupon-select .el-select-dropdown__item.is-disabled{
  color: #A0A0A0;
}
</style>



// WEBPACK FOOTER //
// src/pages/pay/warecheckout.vue